import { gql } from '@apollo/client';

export const GET_CONFIGURATION = gql`
  query getConfiguration($body: ConfigurationRequest!) {
    getConfiguration(body: $body) {
      data
    }
  }
`;

export const GET_CITIES_BY_DEPARTMENT_ID = gql`
  query getCitiesByDepartmentId($departmentId: Int!) {
    getCitiesByDepartmentId(departmentId: $departmentId) {
      data
    }
  }
`;

export const GET_DOCUMENT = gql`
  query getDocument($body: DocumentRequest!) {
    getDocument(body: $body) {
      data
    }
  }
`;

export const GET_SECRET_KEY = gql`
  query getManagerSecretKey($secretManager: String!) {
    getManagerSecretKey(secretManager: $secretManager) {
      data
    }
  }
`;

export const PIN_PUBLIC_KEY = gql`
  query getPublicKey {
    getPublicKey {
      key
    }
  }
`;

export const GET_CONTACT_SUPPORT = gql`
  query contactSupportData {
    contactSupportData {
      data {
        value
        description
        title
        order
        type
        supportHours
        icon
      }
    }
  }
`;

export const SET_ACCEPT_TERMS_AND_TREAT = gql`
  query setLegalUserDocuments($body: SetLegalUserDocumentsRequest!) {
    setLegalUserDocuments(body: $body) {
      data
    }
  }
`;

export const GET_LEGAL_DOCUMENT = gql`
  query GetLegalDocument($type: String!, $person: String!, $action: String!) {
    getLegaldocuments(type: $type, person: $person, action: $action) {
      version
      title
      text
    }
  }
`;
